import { useState } from 'react';
import { useTranslate } from 'react-polyglot';

import { MicrositeIcon } from '@genially/icons';

import { ConfigToggle } from '../ConfigToggle/ConfigToggle';

export const HostCursorToggle = ({
  isEnabled,
  onChange,
}: {
  isEnabled: boolean;
  onChange: () => void;
}) => {
  const t = useTranslate();

  // The host cursor flag is React state in HostGameProvider, which sits below the
  // ModalProvider this modal is rendered from: unlike the rest of the config it is not
  // observable, so nothing here re-renders when it changes. This toggle is its only
  // switch, so a local copy — seeded on each open — keeps up with the clicks.
  const [isChecked, setIsChecked] = useState(isEnabled);

  const handleChange = () => {
    setIsChecked(previous => !previous);
    onChange();
  };

  return (
    <ConfigToggle
      Icon={MicrositeIcon}
      text={t('__new.play.shared.configuration.modal.SwitchCursor')}
      checked={isChecked}
      onChange={handleChange}
    />
  );
};
